import { AnimatePresence, motion } from 'framer-motion'
import { useSelector } from 'react-redux'
import { useBuyBonusFlow } from '@hooks/buyBonus/useBuyBonusFlow'
import { BUY_BONUS_OVERLAY } from '@constants/buyBonusConstants'
import BuyBonusPackagesList from './BuyBonusPackagesList'
import BuyBonusPackageCheckout from './BuyBonusPackageCheckout'
import BuyBonusPaymentStatus from './BuyBonusPaymentStatus'

const fadeScale = {
  initial: { opacity: 0, scale: 0.96 },
  animate: { opacity: 1, scale: 1, transition: { type: 'spring', stiffness: 300, damping: 24 } },
  exit: { opacity: 0, scale: 0.98, transition: { duration: 0.18 } },
}

// Mounted once by OverlayController, entirely gated on `isOpen`. Every hook
// and every state transition lives in useBuyBonusFlow — this component only
// picks which of the 3 pure screens to render, mirroring defenderV2's
// BuyFreebetsOverlay switch.
const BuyBonusOverlay = () => {
  const currencyCode = useSelector((state) => state.wallet.displayCurrencyCode)
  const flow = useBuyBonusFlow()

  if (!flow.isOpen) return null

  return (
    <div className="standard-normal-buy-bonus-overlay-outer-container">
      <AnimatePresence mode="wait">
        {flow.currentOverlay === BUY_BONUS_OVERLAY.PACKAGES_LIST && (
          <motion.div
            key={BUY_BONUS_OVERLAY.PACKAGES_LIST}
            className="standard-normal-buy-bonus-overlay-motion-wrapper"
            {...fadeScale}
          >
            <BuyBonusPackagesList
              packages={flow.packages}
              currencyCode={currencyCode}
              selectedPackage={flow.selectedPackage}
              isLoading={flow.isLoading}
              isEmpty={flow.isEmpty}
              onSelectPackage={flow.onSelectPackage}
              onProceed={flow.onProceedToCheckout}
              onClose={flow.onClose}
            />
          </motion.div>
        )}

        {flow.currentOverlay === BUY_BONUS_OVERLAY.PACKAGE_CHECKOUT && (
          <motion.div
            key={BUY_BONUS_OVERLAY.PACKAGE_CHECKOUT}
            className="standard-normal-buy-bonus-overlay-motion-wrapper"
            {...fadeScale}
          >
            <BuyBonusPackageCheckout
              selectedPackage={flow.selectedPackage}
              currencyCode={currencyCode}
              isPurchasing={flow.isPurchasing}
              onBack={flow.onBackToList}
              onClose={flow.onClose}
              onPurchase={flow.onPurchase}
            />
          </motion.div>
        )}

        {flow.currentOverlay === BUY_BONUS_OVERLAY.PACKAGE_PAYMENT_STATUS && (
          <motion.div
            key={BUY_BONUS_OVERLAY.PACKAGE_PAYMENT_STATUS}
            className="standard-normal-buy-bonus-overlay-motion-wrapper"
            {...fadeScale}
          >
            <BuyBonusPaymentStatus
              paymentStatus={flow.paymentStatus}
              selectedPackage={flow.selectedPackage}
              currencyCode={currencyCode}
              onClose={flow.onClose}
              onFinalAction={flow.onFinalAction}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default BuyBonusOverlay
